import { useEffect, useRef } from 'react';
import { MapOverlayConfig } from '@/map/types/overlay';

interface MapOverlayProps {
  map: google.maps.Map | null;
  config: MapOverlayConfig;
}

export const MapOverlay = ({ map, config }: MapOverlayProps) => {
  const overlayRef = useRef<google.maps.ImageMapType | null>(null);

  useEffect(() => {
    if (!map || !config) return;

    const getTileUrl = (coord: google.maps.Point, zoom: number): string => {
      if (zoom < config.min_zoom || zoom > config.max_zoom) {
        return '';
      }

      let x = coord.x;
      let y = coord.y;

      if (config.scheme === 'tms') {
        const numTiles = Math.pow(2, zoom);
        y = numTiles - 1 - y;
      }

      return config.tile_url_template
        .replace('{z}', zoom.toString())
        .replace('{x}', x.toString())
        .replace('{y}', y.toString());
    };

    const imageMapType = new google.maps.ImageMapType({
      getTileUrl,
      tileSize: new google.maps.Size(256, 256),
      opacity: config.opacity,
      name: `Overlay ${config.version}`,
    });

    map.overlayMapTypes.push(imageMapType);
    overlayRef.current = imageMapType;

    return () => {
      if (overlayRef.current) {
        const index = map.overlayMapTypes.getArray().indexOf(overlayRef.current);
        if (index !== -1) {
          map.overlayMapTypes.removeAt(index);
        }
        overlayRef.current = null;
      }
    };
  }, [map, config]);

  useEffect(() => {
    if (overlayRef.current) {
      overlayRef.current.setOpacity(config.opacity);
    }
  }, [config.opacity]);

  return null;
};
